import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=843e1e90&scoped=true&"
import script from "./tab.vue?vue&type=script&lang=js&"
export * from "./tab.vue?vue&type=script&lang=js&"
import style0 from "./tab.vue?vue&type=style&index=0&id=843e1e90&lang=less&scoped=true&"
import style1 from "./tab.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843e1e90",
  null
  
)

export default component.exports